const _ = require('underscore');
const React = require('react');
const createReactClass = require("create-react-class");
const Modal = require('../../deploynaut/js/Modal.jsx');
const AddSecretForm = require('./AddSecretForm.jsx');
const RemoveSecretForm = require('./RemoveSecretForm.jsx');
const moment = require('moment');

const Secrets = createReactClass({
	getInitialState: function() {
		let model = this.props.model;
		model.SecurityID = this.props.model.InitialSecurityID;
		delete(model.InitialSecurityID);

		let initialMessage = { type: 'success', body: '' };
		if (model.Error) {
			initialMessage = { type: 'error', body: model.Error };
		}

		return {
			message: initialMessage,
			model: this.props.model,
			SecretsNeedFullDeploy: this.props.model.SecretsNeedFullDeploy,
			addingSecret: false,
			removingSecret: false,
			removingSecretId: null
		};
	},

	afterModalClose(data) {
		let newState = {
			addingSecret: false,
			removingSecret: false,
			removingSecretId: null,
			message: {
				type: 'success',
				body: data.message
			}
		};

		if (typeof data.data.Secrets === "object") {
			newState.model = this.state.model;
			newState.model.Secrets = data.data.Secrets;
			newState.SecretsNeedFullDeploy = data.data.SecretsNeedFullDeploy;
		}

		this.setState(newState);
	},

	cancelHandler: function(event) {
		if(event) {
			event.preventDefault();
		}
		this.setState({
			addingSecret: false,
			removingSecret: false,
		});
	},

	getModal: function (form, title) {
		if(!form) {
			return null;
		}
		return (
			<Modal
				closeHandler={this.cancelHandler}
				title={title}
			>
				{form}
			</Modal>
		);
	},

	showAddModal: function() {
		this.setState(prevState => ({
			addingSecret: !prevState.addingSecret
		}));
	},

	showRemoveModal: function(data) {
		this.setState(prevState => ({
			removingSecret: !prevState.removingSecret,
			removingSecretId: data.id
		}));
	},

	render: function() {
		let message = null;
		if (this.state.message.body) {
			message = <Message type={this.state.message.type} message={this.state.message.body} />
		}


		let deployNeededMessage = null;
		if (this.state.SecretsNeedFullDeploy) {
			deployNeededMessage = (
				<div className="alert alert-warning"
					 dangerouslySetInnerHTML={{__html:this.props.model.FullDeployNeededMessage}} />
			);
		}


		let stepModal = null;
		if (this.state.addingSecret) {
			stepModal = this.getModal((
				<AddSecretForm
					actionURL={this.props.model.AddSecretActionURL}
					afterSuccess={this.afterModalClose}
					cancelHandler={this.cancelHandler}
					model={this.state.model}
				/>
			), 'Add a secret');
		}

		if (this.state.removingSecret) {
			stepModal = this.getModal((
				<RemoveSecretForm
					actionURL={this.props.model.RemoveSecretActionURL}
					afterSuccess={this.afterModalClose}
					cancelHandler={this.cancelHandler}
					model={this.state.model}
					id={this.state.removingSecretId}
				/>
			), 'Remove secret');
		}

		let addBtn = null;
		if (this.state.model.CanUpdateSecrets) {
			addBtn = (
				<button
					type="button"
					className="btn btn-primary"
					onClick={this.showAddModal}
				>
					Add a secret
				</button>
			)
		}

		return (
			<div className="secrets">
				{message}
				{deployNeededMessage}
				<SecretList
					secrets={this.state.model.Secrets}
					environment={this.state.model.EnvironmentVhostCode}
					canUpdate={this.state.model.CanUpdateSecrets}
					removeHandler={this.showRemoveModal}
				/>
				<div className="actions btn-toolbar">
					{addBtn}
				</div>
				{stepModal}
			</div>
		);
	}
});

const Message = createReactClass({
	render: function() {
		return (
			<div
				className={'alert alert-' + this.props.type}
				dangerouslySetInnerHTML={{__html:this.props.message}}
			/>
		);
	}
});

const SecretList = createReactClass({
	render: function() {
		const props = this.props;
		let rows = _.map(this.props.secrets, function(item) {
			return (
				<Secret
					key={item.id}
					secret={item}
					environment={props.environment}
					removeHandler={props.removeHandler}
					canUpdate={props.canUpdate}
				/>
			);
		});

		if (!rows.length) {
			rows = (
				<tr>
					<td colSpan="6" className="text-center">No secrets have been added</td>
				</tr>
			)
		}

		return (
			<div className="secrets table-responsive">
				<table className="table table-fullwidth">
					<thead>
					<tr>
						<th></th>
						<th width="25%">Name</th>
						<th>Type</th>
						<th></th>
						<th>Added by</th>
						<th>Created</th>
						<th></th>
					</tr>
					</thead>
					<tbody>
						{rows}
					</tbody>
				</table>
			</div>
		);
	}
});

const Secret = createReactClass({
	getNiceType() {
		if (this.props.secret.attributes.type === "Environment variable") {
			return (
				<div>
					Environment variable<br />
					<small>Accessible by referencing the PHP or .htaccess constant <code>{this.props.secret.attributes.name}</code></small>
				</div>
			);
		}

		return (
			<div>
				Local file<br />
				<small>Accessible by reading the file <code>/var/secrets/{this.props.environment}/{this.props.secret.attributes.name}</code></small>
			</div>
		);
	},

	render: function() {
		let message = null;
		let action = <button type="button" className="btn btn-xs btn-danger" onClick={() => this.props.removeHandler(this.props.secret)}><i className="fa fa-times no-text" title="Delete" /></button>;
		if (this.props.secret.attributes.locked) {
			action = <i className="fa fa-lock" title="This secret has been automatically provisioned and cannot be removed" />;
		}
		if (this.props.secret.attributes.inherited) {
			action = <i className="fa fa-lock" title="This secret must be managed at the stack level" />;
			message = <em title="This secret has been added to the stack, which is added to every environment belonging to the stack">Inherited from stack</em>;
		}
		if (this.props.secret.attributes.overridden) {
			message = <em title="This secret will take precedence over a stack secret with the same name">Overriding stack secret</em>;
		}

		let creator = null;
		if (this.props.secret.attributes.creator) {
			creator = this.props.secret.attributes.creator.name
		}

		if (!this.props.canUpdate) {
			action = null;
		}

		return (
			<tr>
				<td></td>
				<td><code>{this.props.secret.attributes.name}</code></td>
				<td>{this.getNiceType()}</td>
				<td>{message}</td>
				<td>{creator}</td>
				<td title={this.props.secret.attributes.created}>{moment(this.props.secret.attributes.created).fromNow()}</td>
				<td className="text-center">{action}</td>
			</tr>
		);
	}

});
module.exports = Secrets;
